import ForbiddenPage from "../pages/error/ForbiddenPage";
import NotFoundPage from "../pages/error/NotFoundPage";
import ServerErrorPage from "../pages/error/ServerErrorPage";

export const errorRoutes = [
  {
    name: "Not Found",
    path: "404",
    element: <NotFoundPage />,
  },
  {
    name: "Server Error",
    path: "500",
    element: <ServerErrorPage />,
  },
  {
    name: "Forbidden",
    path: "403",
    element: <ForbiddenPage />,
  },
];
